import { MemberChangeRequests as MemberChangeRequestsComponent } from '../../../components/ChangeRequest';

export function MemberChangeRequests() {
  return <MemberChangeRequestsComponent />;
}
